import { Component, OnInit, Inject } from '@angular/core';
import { DailyReviewService } from 'dm-src/app/modules/daily-review/daily-review.service';
import { AUTH_SERVICE_IMPL, IAuthenticationService } from 'shared';
import { PaySafe } from 'dm-src/dtos/pay-safe';

@Component({
    selector: 'app-cash-payments',
    templateUrl: './cash-payments.component.html',
    styleUrls: ['./cash-payments.component.scss'],
})
export class CashPaymentsComponent implements OnInit {
    public paySafe: PaySafe = new PaySafe();
    public isNewWrapper = !!window.ReactNativeWebView;

    constructor(
        @Inject(AUTH_SERVICE_IMPL)
        private _authService: IAuthenticationService,
        private _dailyReviewService: DailyReviewService
    ) {}

    public openPaySafeUrlInBrowser(): void {
        this._dailyReviewService
            .savePaySafeReferenceWithOrderCodes(
                this.paySafe.paySafeReference,
                this.paySafe.orderCodes).subscribe(response =>{
                    if (response.status === 200) {
                        const paySafeUrl = this.paySafeUrl;

                        if (this.isNewWrapper) {
                            paySafeUrl.replace("https", "openurlinbrowser");
                        }

                        window.open(paySafeUrl, '_blank');
                    } else {
                        console.log(JSON.stringify(response));
                    }
                },
                (error) => {
                    console.log(JSON.stringify(error));
                });
    }

    public get paySafeUrl(): string
    {
        return `${this.paySafe.paySafeUrl}?mid=${this.paySafe.paySafeMerchantID}&amount=${this.paySafe.amount}&reference=${this.paySafe.paySafeReference}`
    }

    ngOnInit(): void {
        const userID = this._authService.currentUser.userID;

        this._dailyReviewService
            .getCashPayments(userID)
            .subscribe((result) => {
                this.paySafe = result;
            });
    }
}
